<template>
    <label
        class="c-color-card-button o-flex-center"
        :class="{
            'c-color-card-button--selected': isSelected,
            'c-color-card-button--not-available': !isAvailable,
        }"
        :for="id"
    >
        <div
            class="c-color-card-button__color"
            :style="getStyles"
        >
        </div>
    </label>
</template>

<script>
import { formatHexColor } from '~coreModules/core/js/utils';

export default {
    name: 'ColorCardButton',
    props: {
        id: {
            type: String,
            default: null,
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
        isAvailable: {
            type: Boolean,
            default: true,
        },
        color: {
            type: Object,
            default: null,
        },
    },
    emits: ['click'],
    computed: {
        getStyles() {
            return {
                backgroundImage: this.color?.imageUrl && `url('${this.color?.imageUrl}')`,
                backgroundColor: this.formattedHexValue,
            };
        },
        formattedHexValue() {
            if (!this.color?.hexCode) return '#ffffff';
            return formatHexColor(this.color?.hexCode);
        },
    },
};
</script>

<style lang="scss">
    .c-color-card-button {
        $this: &;

        width: $nu-spacer-5;
        height: $nu-spacer-5;
        border: 1px solid transparent;
        box-sizing: content-box;
        border-radius: 50%;
        cursor: pointer;
        transition: border-color 0.2s ease;

        &:hover, &--selected {
            border-color: $nu-primary;
        }

        &__color {
            display: block;
            position: relative;
            width: $nu-spacer-4;
            height: $nu-spacer-4;
            background-size: contain;
            border: 1px solid $nu-gray--medium;
            border-radius: 50%;
            background-position: center center;

            #{$this}--not-available & {
                border-color: $nu-white;

                &::after {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    overflow: hidden;
                    content: '';

                    background:
                        linear-gradient(to top right,
                            rgba($nu-black, 0.1) 0%,
                            rgba($nu-black, 0.1) calc(50% - 1px),
                            $nu-white calc(50% - 1px),
                            $nu-white calc(50% + 1px),
                            rgba($nu-black, 0.1) calc(50% + 1px),
                            rgba($nu-black, 0.1) 100%);
                }
            }
        }
    }
</style>
